import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cms-project-planning',
  styleUrl: 'cms-project-planning.scss',
  shadow: true,
})
export class CmsProjectPlanning {
  private readonly challengeLevels = 5;
  /**
   * set the Challenge Level
   */
  @Prop() challenge: number = 1 | 2 | 3 | 4 | 5;
  /**
   * set the Challenge text
   */
  @Prop() challengeText: string;
  /**
   * set the challenge label like Herausforderung
   */
  @Prop() challengeLabel: string;
  /**
   * set the build Time like 10 Minuten
   */
  @Prop() buildTime: string;
  /**
   * set the build Time Label like Zeitaufwand
   */
  @Prop() buildTimeLabel: string;
  /**
   * set number of makers
   */
  @Prop() doer: string;
  /**
   * set the label of makers like Macher
   */
  @Prop() doerLabel: string;
  /**
   * set the Project Price
   */
  @Prop() projectPrice: string;
  /**
   * set the label Project Price like Projektpreis
   */
  @Prop() projectPriceLabel: string;

  private renderIndicatorDots() {
    const content = [];
    for (let index = 1; index <= this.challengeLevels; index++) {
      if (index <= this.challenge) {
        content.push(<span class={'dot'} />);
      } else {
        content.push(<span class={'blank-dot'} />);
      }
    }
    return content;
  }

  render() {
    const svgWrapperClass = 'svg-wrapper';
    const accessibilityAttributes = {
      'aria-label': this.challengeText,
      title: this.challengeText,
    };
    return (
      <Host>
        <div class='feasibility-box'>
          {this.challenge !== undefined ? (
            <div class='feasibility-challenge'>
              <span class={svgWrapperClass}>
                <cms-icon
                  size='md'
                  icon='hammer'
                  colorToken='--cms-semanticColors-base-strong-icon'
                  alt=''
                />
              </span>
              <span class='feasibility-label challenge'>
                {this.challengeLabel}
              </span>
              <div
                class='feasibility-value challenge-indicator'
                {...accessibilityAttributes}
              >
                {this.renderIndicatorDots()}
              </div>
            </div>
          ) : null}
          {this.buildTime !== undefined &&
          this.buildTime !== '' &&
          this.buildTime !== '0' ? (
            <div class={'feasibility-work-time'}>
              <span class={svgWrapperClass}>
                <cms-icon
                  size='md'
                  icon='clock'
                  colorToken='--cms-semanticColors-base-strong-icon'
                  alt=''
                />
              </span>
              <span class={'feasibility-label work-time'}>
                {this.buildTimeLabel}
              </span>
              <div class={'feasibility-value work-time-value'}>
                {this.buildTime}
              </div>
            </div>
          ) : null}
          {this.doer !== undefined && this.doer !== '0' ? (
            <div class={'feasibility-doer'}>
              <span class={svgWrapperClass}>
                <cms-icon
                  size='md'
                  icon='projects'
                  alt=''
                  colorToken='--cms-semanticColors-base-strong-icon'
                />
              </span>
              <span class={'feasibility-label doer'}>{this.doerLabel}</span>
              <div class={'feasibility-value doer-value'}>{this.doer}</div>
            </div>
          ) : null}
          {this.projectPrice !== undefined && this.projectPrice !== '0' ? (
            <div class={'feasibility-project-price'}>
              <span class={svgWrapperClass}>
                <cms-icon
                  size='md'
                  icon='euro'
                  colorToken='--cms-semanticColors-base-strong-icon'
                  alt=''
                />
              </span>
              <span class={'feasibility-label project-price'}>
                {this.projectPriceLabel}
              </span>
              <div class={'feasibility-value project-price-value'}>
                ca. {this.projectPrice},-
              </div>
            </div>
          ) : null}
        </div>
      </Host>
    );
  }
}
